export default __webpack_public_path__ + "static/media/373.16b5142c.png";